module.exports = __webpack_public_path__ + "img/ИФ-1(А)-052.54a73d6c.png";